<template>
  <div>
    <div v-for="(obj, key) in group" :key="calculateKey(key)">
      <TranslationCollapsableGroup
        @input="updateTranslation"
        :collapsed="collapsed"
        :group="obj"
        :depth="depth"
        :parentKey="key"
      />
    </div>
  </div>
</template>
<script>
import TranslationCollapsableGroup from '@/web/components/settings/TranslationCollapsableGroup.vue';

export default {
  name: 'TranslationGroup',
  components: {
    TranslationCollapsableGroup,
  },
  props: {
    group: {
      type: Object,
    },
    depth: {
      type: Number,
      default: 1,
    },
    collapsed: {
      type: Boolean,
      default: true,
    },
    parentKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    depthClass() {
      return `h${this.depth + 1}`;
    },
  },
  data() {
    return {};
  },
  methods: {
    updateTranslation({ translationText, translationKey }) {
      this.$emit('input', { translationText, translationKey });
    },
    calculateKey(key) {
      if (!this.parentKey) {
        return key;
      }
      return `${this.parentKey}.${key}`;
    },
  },
};
</script>
<style lang="scss" scoped></style>
